import api from '@/api/api';

const state = {
    logs: [],
    targetBuilds: [],
};

const getters = {
    logs: state => state.logs,
    targetBuilds: state => state.targetBuilds,
};

const mutations = {
    SET_LOGS(state, logs) {
        state.logs = logs;
    },
    SET_TARGET_BUILDS(state, targetBuilds) {
        state.targetBuilds = targetBuilds;
    },
};

const actions = {
    /**
     * Search logs by query and save it to state.
     * @return {Promise} result.
     */
    async searchLogs({ commit }, query) {
        try {
            const { files, target_builds } = await api.logs.search(query);
            commit('SET_LOGS', files);
            commit('SET_TARGET_BUILDS', target_builds);
        } catch (error) {
            return Promise.reject('Error of logs list fetching');
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
